import { useLayoutEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 * This hook needs to be typed with the referenced object type
 */
const useKeydown = (enable: boolean, callback: (event: KeyboardEvent) => void): void => {
  useLayoutEffect(() => {
    if (enable) {
      document.addEventListener('keydown', callback);
    } else {
      document.removeEventListener('keydown', callback);
    }

    return (): void => {
      document.removeEventListener('keydown', callback);
    };
  }, [callback, enable]);
};

export default useKeydown;
